
























































import { Component, PropSync, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Kanban_List_Gantt extends Vue {
  @PropSync("view") icon!: any;
}
